import {
    CREATE_PRINTING_DC_INWARD_DETAILS_REQUEST,
    CREATE_PRINTING_DC_INWARD_DETAILS_SUCCESS,
    CREATE_PRINTING_DC_INWARD_DETAILS_FAILURE,
    DELETE_PRINTING_DC_INWARD_DETAILS_REQUEST,
    DELETE_PRINTING_DC_INWARD_DETAILS_SUCCESS,
    DELETE_PRINTING_DC_INWARD_DETAILS_FAILURE,
    FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_REQUEST,
    FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_SUCCESS,
    FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_FAILURE,
    FETCH_PRINTING_DC_INWARD_DETAILS_REQUEST,
    FETCH_PRINTING_DC_INWARD_DETAILS_SUCCESS,
    FETCH_PRINTING_DC_INWARD_DETAILS_FAILURE,
    UPDATE_PRINTING_DC_INWARD_DETAILS_REQUEST,
    UPDATE_PRINTING_DC_INWARD_DETAILS_SUCCESS,
    UPDATE_PRINTING_DC_INWARD_DETAILS_FAILURE,
    RESET_PRINTING_DC_INWARD_DETAILS_INFO,
    CREATE_PRINTING_DC_INWARD_DETAILS_FORM,
    UPDATE_PRINTING_DC_INWARD_DETAILS_FORM,
    FETCH_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_SUCCESS,
    FETCH_PREVIOUS_PRINTING_INWARD_DETAILS_REQUEST,
    FETCH_PREVIOUS_PRINTING_INWARD_DETAILS_SUCCESS,
    PRINTING_INWARD_DETAILS_PO_DETAILS_DISABLED,
    CREATE_PRINTING_INWARD_DETAIL_EDIT_QTY_MASTER_REQUEST,
    CREATE_PRINTING_INWARD_DETAIL_EDIT_QTY_MASTER_SUCCESS,
    CREATE_PRINTING_INWARD_DETAIL_EDIT_QTY_MASTER_FAILURE,
    CREATE_USER_FORM_PRINTING_INWARD_EDIT_QTY,
    RESET_PRINTING_INWARD_EDIT_QTY,
    FETCH_PRINTING_INWARD_DETAIL_EDIT_QTY_MASTER_REQUEST,
    FETCH_PRINTING_INWARD_DETAIL_EDIT_QTY_MASTER_SUCCESS,
    FETCH_PRINTING_INWARD_DETAIL_EDIT_QTY_MASTER_FAILURE,
    RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_PRINTING_INWARD_ID,
    SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_PRINTING_INWARD_ID,
    PRINTING_INWARD_DETAILS_USERFORM_RESET
} from './printingDcInwardDetails.actionsType';

export const PRINTING_DC_INWARD_DETAILS = 'printingDcInwardDetails';

let initialState = {
    loading: false,
    printingDcInwardDetails: [],
    isDisabledDC: false,
    printingDcInwardDetailsWithoutId: [],
    previousGetList: [],
    printingDcInwardDetailsForm: {
        fldItemRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0,
        fldPOQuantity: 0,
        fldInwardQuantity: 0
    },
    selectedState: {},
    errorMessage: '',
    editPrintingQtyList: [],
    editGridData: []
};

export let printingDcInwardDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PRINTING_DC_INWARD_DETAILS_REQUEST:
        case FETCH_PREVIOUS_PRINTING_INWARD_DETAILS_REQUEST:
        case CREATE_PRINTING_DC_INWARD_DETAILS_REQUEST:
        case UPDATE_PRINTING_DC_INWARD_DETAILS_REQUEST:
        case FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_REQUEST:
        case DELETE_PRINTING_DC_INWARD_DETAILS_REQUEST:
        case FETCH_PRINTING_INWARD_DETAIL_EDIT_QTY_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_PRINTING_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDcInwardDetailsWithoutId: updatePayload
            };
        case FETCH_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_SUCCESS:
            return {
                ...state,
                loading: false,

                printingDcInwardDetailsWithoutId: updatePayload
            };
        case FETCH_PREVIOUS_PRINTING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload?.CUD,
                editGridData: updatePayload?.CUD
            };
        case CREATE_PRINTING_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDcInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                },
                isDisabledDC: false
            };
        case RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_PRINTING_INWARD_ID:
            return {
                ...state,
                loading: false,
                editGridData: []
            };
        case UPDATE_PRINTING_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedState: {},
                printingDcInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                },
                isDisabledDC: false
            };
        case FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDcInwardDetailsForm: updatePayload
            };
        case DELETE_PRINTING_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDcInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                },
                isDisabledDC: false,
                selectedState: {}
            };
        case RESET_PRINTING_DC_INWARD_DETAILS_INFO:
            return {
                ...state,
                printingDcInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                },
                isDisabledDC: false
            };
        case CREATE_PRINTING_DC_INWARD_DETAILS_FORM:
        case UPDATE_PRINTING_DC_INWARD_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                printingDcInwardDetailsForm: {
                    ...state.printingDcInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case PRINTING_INWARD_DETAILS_PO_DETAILS_DISABLED:
            return {
                ...state,
                isDisabledDC: payload
            };
        case FETCH_PRINTING_INWARD_DETAIL_EDIT_QTY_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                editGridData: updatePayload?.CUD || []
            };
        case RESET_PRINTING_INWARD_EDIT_QTY:
            return {
                ...state,
                loading: false,
                editPrintingQtyList: []
            };

        case CREATE_USER_FORM_PRINTING_INWARD_EDIT_QTY:
            return {
                ...state,
                loading: false,
                // userform: {
                //     ...state.userform
                // },
                editPrintingQtyList: payload
            };
        case FETCH_PRINTING_DC_INWARD_DETAILS_FAILURE:
        case FETCH_PREVIOUS_PRINTING_INWARD_DETAILS_REQUEST:
        case CREATE_PRINTING_DC_INWARD_DETAILS_FAILURE:
        case UPDATE_PRINTING_DC_INWARD_DETAILS_FAILURE:
        case FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_FAILURE:
        case DELETE_PRINTING_DC_INWARD_DETAILS_FAILURE:
        case FETCH_PRINTING_INWARD_DETAIL_EDIT_QTY_MASTER_FAILURE:
            return {
                ...state,
                loading: false
            };
        case SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_PRINTING_INWARD_ID:
            return {
                ...state,
                loading: false,
                editGridData: payload
            };
        case PRINTING_INWARD_DETAILS_USERFORM_RESET:
            return {
                ...state,
                printingDcInwardDetailsForm: {
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                selectedState: {},
                isDisabledDC: false
            };
        default:
            return state;
    }
};
